export enum CodecType {
  Opus = '1',
  AAC = '2'
}
